import { persistStore } from "reduxjs-toolkit-persist";
import { AppStore } from "./store";
import {Persistor} from "reduxjs-toolkit-persist/lib/types";

export const persistor: Persistor = persistStore(AppStore);
